import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_DOCUMENT_CLAUSES_QUERY = gql`
  query pagedDocumentClauses($pager: PagerInputNew, $filters: DocumentClausesFilterInput) {
    pagedDocumentClauses(pager: $pager, filters: $filters) {
      total
      values {
        ...documentClause
      }
    }
  }
  ${Fragments.documentClause}
`;

export const DOCUMENT_CLAUSES_FILTERS_QUERY = gql`
  {
    documentClauseListFilters @client {
      fullTextFilter {
        value
      }
      parentClause {
        value
      }
      clauseCode {
        value
      }
      clauseText {
        value
      }
    }
  }
`;
